window.addEventListener("load", function () {
  let accordian = document.querySelector(
    ".accordion--faq-wrapper .accordion-container > .accordion-content .collapsible-tab"
  );
  let bottomGapHeight = 15;
  let contentBlockheight =
    document.querySelector(
      ".accordion--faq-wrapper .accordion-container > .accordion-content .collapsible-tab .collapsible-content .content"
    ).offsetHeight +
    bottomGapHeight +
    "px";
  accordian.classList.add("open");
  document.querySelector(
    ".accordion--faq-wrapper .accordion-container > .accordion-content .collapsible-tab .collapsible-content"
  ).style.height = contentBlockheight;
});

window.addEventListener("load", function () {
  let ratingStars = document.querySelector(
    ".product-form-block .jdgm-prev-badge"
  );
  let ratingWidget = document.querySelector(
    ".shopify-section.main-tabs-accordion-wrapper"
  );
  let headerHeight = 190;

  function scrollToWidget() {
    if (ratingWidget) {
      // Calculate the top offset position of the widget
      let topOffset =
        ratingWidget.getBoundingClientRect().top +
        window.scrollY -
        headerHeight;

      // Perform the scroll
      window.scrollTo({
        top: topOffset,
        behavior: "smooth", // Smooth scrolling
      });

      // Activate the last tab
      let tabs = document.querySelectorAll(
        ".main-tabs-accordion-wrapper .tabs-accordion-container .tab-header .tab-link"
      );
      let tabContent = document.querySelectorAll(
        ".main-tabs-accordion-wrapper .tabs-accordion-container .tab-content .tab"
      );

      let accordions = document.querySelectorAll(
        ".main-tabs-accordion-wrapper .mobile-visible-active .accordions-wrapp--inner .accordion-header"
      );

      tabs.forEach((tab) => {
        tab.classList.remove("active");
      });

      tabs.forEach((tab) => {
        let lastSpan = tab.querySelector("span");
        if (lastSpan.textContent === "BEWERTUNGEN") {
          // Add 'active' class to the parent element
          lastSpan.parentElement.classList.add("active");

          // Get the data-tab attribute of the parent element
          let dataTab = lastSpan.parentElement.getAttribute("data-tab");

          // Loop through tabContent to find the matching data-tab
          tabContent.forEach((content) => {
            // Remove 'active' class from all tab contents
            content.classList.remove("active");

            // Add 'active' class to the matching tab content
            if (content.getAttribute("id") === dataTab) {
              content.classList.add("active");
            }
          });
        }
      });

      // lastTab.classList.add('active');

      // tabContent.forEach(content => content.classList.remove('active'));
      // lastTabContent.classList.add('active');

      accordions.forEach((accordion) => accordion.classList.remove("active"));
      accordions.forEach((accordion) => {
        let accordionHead = accordion.querySelector(".accordion--heading");
        if (accordionHead.textContent === "BEWERTUNGEN") {
          accordionHead.parentElement.classList.add("active");
        }
      });
    }
  }

  // Add a delay to ensure elements are loaded
  setTimeout(function () {
    //console.log('Rating',ratingStars);
    if (ratingStars) {
      ratingStars.addEventListener("click", scrollToWidget);
    }
  }, 1000);
});

let buttons = document.querySelectorAll(".anchor-to-hero-section");
if (buttons) {
  buttons.forEach(function (anchor) {
    anchor.addEventListener("click", function (event) {
      // Prevent default behavior if it's an anchor link
      event.preventDefault();

      // Smoothly scroll to the top
      window.scrollTo({
        top: 0,
        behavior: "smooth", // This makes the scroll smooth
      });
    });
  });
}

// For Tabs

document.addEventListener("DOMContentLoaded", function () {
  const headings = document.querySelectorAll("h2");

  headings.forEach((heading, index) => {
    // Check if the heading is not empty
    if (heading.textContent.trim() !== "") {
      // Generate a unique ID based on the text content
      const id = heading.textContent.trim().toLowerCase().replace(/\s+/g, "-");
      // heading.id = id; // Assign the generated ID to the heading
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const headings = document.querySelectorAll("h2");
  const sidebarList = document.createElement("ul");

  headings.forEach((heading) => {
    // Check if the heading is not empty
    if (heading.textContent.trim() !== "") {
      const id = heading.textContent.trim().toLowerCase().replace(/\s+/g, "-");
      // heading.id = id;
      const listItem = document.createElement("li");
      const link = document.createElement("a");

      // Set the link href to the heading ID for smooth scrolling
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;

      link.addEventListener("click", function (event) {
        event.preventDefault();
        // Scroll to the heading without changing the URL
        document.getElementById(id).scrollIntoView({ behavior: "smooth" });
      });

      // Append link to list item, and list item to the sidebar list
      listItem.appendChild(link);
      sidebarList.appendChild(listItem);
    }
  });

  // Append the sidebar list to your sidebar or desired section
  document
    .querySelector(".table-content-headings-wrapper")
    .appendChild(sidebarList);
});

// Collection Filter Button script For Mobile

$(document).ready(function () {
  $(".mobile-facets__open").click(function () {
    $("#NavDrawer").hide();
  });

  $("collection-filtering-form .drawer__close button").click(function () {
    $("#NavDrawer").show(2000); // Agar aap chahte hain ke wapas dikhai de
  });
});

// Product Page thumbnail

// function updateThumbnailSelection() {
//   var activeImageId = $(".product-medias .product-medias__main .swiper-slide-active img").data("media-id");

//   $(".product-medias .product-medias__thumbnails a").each(function() {
//     var thumbnailId = $(this).data("media-id");

//     if (thumbnailId === activeImageId) {
//       $(this).addClass("product-single__media--selected");
//     } else {
//       $(this).removeClass("product-single__media--selected");
//     }
//   });
// }

// // Run the function every 1000ms (1 second)
// setInterval(updateThumbnailSelection, 1000);

document.addEventListener("DOMContentLoaded", function () {
  // const swiperInstance = new Swiper(".swiper-container", {
  //   slidesPerView: 1,
  //   loop: false,
  //   observer: true, // Watches for DOM updates
  //   observeParents: true, // Watches for parent container changes
  //   watchSlidesProgress: true, // Helps track the active slide
  //   on: {
  //     slideChangeTransitionEnd: function () {
  //       setTimeout(updateActiveThumbnail, 100);
  //     },
  //     touchEnd: function () { // Detects mobile swipes
  //       setTimeout(updateActiveThumbnail, 100);
  //     },
  //   },
  // });

  // function updateActiveThumbnail() {
  //   const activeSlide = document.querySelector(".product-medias__main .swiper-slide.swiper-slide-active");
  //   if (!activeSlide) return;
    
  //   const activeMediaId = activeSlide.getAttribute("data-media-id");
  //   if (!activeMediaId) return;

  //   const thumbnails = document.querySelectorAll("a.product-medias__thumbnail");

  //   thumbnails.forEach((thumbnail) => {
  //     if (thumbnail.getAttribute("data-media-id") === activeMediaId) {
  //       thumbnail.classList.add("product-single__media--selected");
  //     } else {
  //       thumbnail.classList.remove("product-single__media--selected");
  //     }
  //   });
  // }

  // updateActiveThumbnail(); // Initial check
});

  // document.addEventListener("DOMContentLoaded", function () {
  //     var thumbnailSwiper = new Swiper(".thumbnail-swiper", {
  //       direction: "vertical",
  //       slidesPerView: 7,
  //       spaceBetween: 10,
  //       watchSlidesProgress: true,
  //       slideToClickedSlide: true,
  //       navigation: {
  //         nextEl: ".thumbnail-next",
  //         prevEl: ".thumbnail-prev",
  //       },
  //       breakpoints: {
  //         0: {
  //           direction: "horizontal",
  //           slidesPerView: 5,
  //         },
  //         480: {
  //           direction: "vertical",
  //           slidesPerView: 7,
  //         }
  //       }
  //     });
      
  //     var mainSwiper = new Swiper(".main-swiper", {
  //       slidesPerView: 1,
  //       spaceBetween: 10,
  //       loop: true,
  //       navigation: {
  //         nextEl: ".swiper-button-next",
  //         prevEl: ".swiper-button-prev",
  //       },
  //       pagination: {
  //         el: ".swiper-pagination",
  //         clickable: true,
  //       },
  //       thumbs: {
  //         swiper: thumbnailSwiper
  //       }
  //     });
      
  //     const players = Plyr.setup('.plyr');
  //   }, 500);
  // });

document.addEventListener("DOMContentLoaded", function () {
  var thumbnailSwiper = new Swiper(".thumbnail-swiper", {
    direction: "vertical",
    slidesPerView: 7,
    spaceBetween: 10,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    navigation: {
      nextEl: ".thumbnail-next",
      prevEl: ".thumbnail-prev",
    },
    breakpoints: {
      0: {
        direction: "horizontal",
        slidesPerView: 7,
        spaceBetween: 2,
      },
      480: {
        direction: "vertical",
        slidesPerView: 7,
      },
    },
  });

  var mainSwiper = new Swiper(".main-swiper", {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    thumbs: {
      swiper: thumbnailSwiper,
    },
  });

  setTimeout(() => {
    Plyr.setup('.plyr');
  }, 500); // Delaying Plyr setup if needed
});

document.addEventListener('DOMContentLoaded', () => {
  // Initialize Plyr for all video elements with the class 'plyr'
  const players = Array.from(document.querySelectorAll('.plyr')).map((player) => new Plyr(player, {
    controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'fullscreen'],
    settings: ['quality', 'speed'],
    volume: 0.5,
  }));

  // Optional: Log initialized players to the console
  console.log('Plyr players initialized:', players);
});

$(document).ready(function () {
  // Loop through each image with the data-media-type attribute
  $('.imageBox img').each(function () {
    // Check if the media type is video or external_video
    if ($(this).attr('data-media-type') === 'video' || $(this).attr('data-media-type') === 'external_video') {
      // Find the closest product-medias__emblem and show it
      $(this).closest('.imageBox').find('.product-medias__emblem').css('display', 'block');
    }
  });
});

$(document).ready(function () {
  $(".thumbnail-swiper .swiper-slide").on("click", function () {
    var mediaId = $(this).data("media-id");
    var mainSlide = $(".main-swiper .swiper-slide[data-media-id='" + mediaId + "']");

    // Stop all videos first
    $(".main-swiper video").each(function () {
      this.pause();
      this.currentTime = 0; // Reset video to start
    });

    // Play the clicked thumbnail's video if it exists
    if (mainSlide.find("video").length) {
      var video = mainSlide.find("video").get(0);
      video.play();
    }
  });
});

  
  function openZoom(img) {
    document.getElementById("zoomed-image").src = img.src;
    document.getElementById("zoom-modal").style.display = "block";
    document.querySelector(".product-form-wrapper").style.position = "unset";
  }

  function closeZoom() {
    document.getElementById("zoom-modal").style.display = "none";
    document.querySelector(".product-form-wrapper").style.position = "sticky";
  }
